import "./Guides.module.css";
import Header from "@/reusable_sections/Header";
import GuidesHero from "./sections/GuidesHero";
import EBookCollection from "./sections/EBookCollection";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function GuidesPage() {
  return <div>
      <Header />
      <GuidesHero />
      <EBookCollection />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}